export default __webpack_public_path__ + "static/media/jogging.76a2c507.svg";